import React from 'react';
import {Link} from 'react-router-dom';
import {CButton} from '@coreui/react';

const TableDetailButton = (props: any) => {
  const {item, color, variant, shape, size, className, toLink, itemBaseLink, itemLinkIdField} = props;
  const navigateTo = itemLinkIdField ? (itemBaseLink ? `${itemBaseLink}${item[itemLinkIdField]}` : `${item[itemLinkIdField]}`) : toLink ? toLink : '';
  // console.log('Navigate to field is: ', navigateTo);
  return (
    <td className="py-2">
      <Link to={`${navigateTo}`}>
        {/* <Link to="forms/new"> */}
        <CButton color="info" variant="outline" shape="square" size="sm" className="mx-1">
          Details
        </CButton>
      </Link>
    </td>
  );
};

export default TableDetailButton;
